import React from 'react'
import { Avatar, AvatarFallback, AvatarImage } from '../../../avatar'
import { Database } from 'lucide-react'

export interface AvatarTextProps {
  user: { 
    name: string
    email: string
    avatar?: string 
  }
  text: string
  onSavePrompt?: (text: string) => void
}

export function AvatarText({ user, text, onSavePrompt }: AvatarTextProps) {
  const [isHovered, setIsHovered] = React.useState(false)

  const handleSavePrompt = () => {
    if (onSavePrompt) {
      onSavePrompt(text)
    }
  }

  return (
    <div 
      className="inline-flex items-start gap-2 rounded-lg relative group border border-border bg-card p-4 max-w-fit"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="flex flex-col items-center gap-1">
        <Avatar className="h-6 w-6 rounded-lg flex-shrink-0">
          <AvatarImage src={user.avatar} alt={user.name} />
          <AvatarFallback className="rounded-lg text-xs">
            {user.name.split(' ').map(n => n[0]).join('').toUpperCase()}
          </AvatarFallback>
        </Avatar>
        
        {/* Database icon shown on hover */}
        {isHovered && onSavePrompt && (
          <button
            onClick={handleSavePrompt}
            className="h-7 w-7 p-1 hover:bg-muted rounded transition-colors flex items-center justify-center"
            title="Save as prompt"
          >
            <Database className="h-4 w-4 text-muted-foreground" />
          </button>
        )}
      </div>
      
      <p className="text-xs leading-4 text-muted-foreground m-0">
        {text}
      </p>
    </div>
  )
}